import React from 'react'
import styled from 'styled-components'

import { installmentStatuses } from '../../constants'
import { formatMoney, sanitizeDate } from '../../helpers'

const AnticipationRow = ({ portion, handleInstallmentClick }) => {
  return (
    <Row onClick={handleInstallmentClick(portion.installment_number - 1)}>
      <Cell mw='50px'>
        <Text>
          {portion.installment_number}/{portion.total_installments}
        </Text>
      </Cell>
      <Cell mw='100px'>R$ {formatMoney(portion.liquidation_transfer_amount)}</Cell>
      <Cell mw='100px'>
        {portion.abbreviation === installmentStatuses.PAID
          ? `R$ ${formatMoney(portion.transfer_amount_delayed || portion.transfer_amount)}`
          : '-'}
      </Cell>
      <Cell mw='80px'>{sanitizeDate(portion.transfer_date)}</Cell>
      <Cell mw='80px'>{sanitizeDate(portion.pay_date)}</Cell>
    </Row>
  )
}

const Row = styled.tr`
  cursor: pointer;
  display: flex;
  background-color: white;
  transition: all 0.3s;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  &:first-child {
    border-top: 1px solid rgba(0, 0, 0, 0.12);
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.075);
    transition: all 0.3s;
  }
  @media (max-width: 769px) {
    font-size: 14px;
  }
`

const Cell = styled.th`
  flex: 1;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  font-weight: normal;
  padding: 15px 5px;
  min-width: ${({ mw }) => mw || '0px'};
`

const Text = styled.p`
  padding: 0 0.5em;
  margin-right: 1.6em;
`

export default AnticipationRow
